/*Sofitel Boutique*/

/*(function(w, d){
    var b = d.getElementsByTagName('head')[0];
    var s = d.createElement("script"); 
    var v = !("IntersectionObserver" in w) ? "8.17.0" : "10.19.0";
    s.defer = true; 
    s.src = "https://cdn.jsdelivr.net/npm/vanilla-lazyload@" + v + "/dist/lazyload.min.js";
    w.lazyLoadOptions = {};
    b.appendChild(s);
}(window, document));*/

var myLazyLoad = new LazyLoad({
    elements_selector: ".lazy"
});
$('html').addClass('us');
$(function() {
    if ($('body.pgproduct #img-right, body.pgproduct #img-left, body.pgproduct #img-icons').length == 0) {
        $('body.pgproduct div.grid-2n').addClass('no-sec').removeClass('sec');
    }
    $('body.pgcategory .title-wrap .stack p').addClass('title-seo-copy');
    var mobile = false;
    var tablet = false;
    var desktop = false;
    
    gsap.config({nullTargetWarn: false})

    function checkWidth() {
        var viewportWidth = window.viewportSize.getWidth();
        if (viewportWidth <= 660) {
            if (!mobile) {
                $('body').addClass('mobile').removeClass('desktop');
                $('body.pgproduct ul.slides li a').contents().unwrap();
                $('body.pgcategory p.title-seo-copy').insertAfter('body.pgcategory div.category');
                $('.header-inner .search').insertAfter('.header-inner .utilities')
            }
            mobile = true;
            desktop = false;
            tablet = false;
        } else if (viewportWidth >= 661 && viewportWidth <= 960) {
            if (!tablet) {
                $('body').removeClass('mobile dekstop').addClass('tablet');
                $('body.pgcategory p.title-seo-copy').insertAfter('body.pgcategory .title-wrap .stack h1');
                $('.header-inner .search').insertBefore('.header-inner .utilities .shop-cart')
                $('#tabs > ul.tab-links li').removeClass('active');
                $('#tabs > ul.tab-links li:first').addClass('active');
                $('#tabs > div#tab-1').not('#tabs > div[id^="img-"]').show();
                $('#tabs > div#tab-3').not('#tabs > div[id^="img-"]').hide();

            }
            mobile = false;
            desktop = false;
            tablet = true;
        } else {
            if (!desktop) {
                $('body').removeClass('mobile').addClass('desktop');
                $('body.pgcategory p.title-seo-copy').insertAfter('body.pgcategory .title-wrap .stack h1');
                $('.header-inner .search').insertBefore('.header-inner .utilities .shop-cart')
                $('#tabs > ul.tab-links li').removeClass('active');
                $('#tabs > ul.tab-links li:first').addClass('active');
                $('#tabs > div#tab-1').not('#tabs > div[id^="img-"]').show();
                $('#tabs > div#tab-3').not('#tabs > div[id^="img-"]').hide();
            }
            mobile = false;
            desktop = true;
            tablet = false;
        }
        var flexImgWidth = $('body.pgproduct div.item-image').width();
        var flexImgHeight = flexImgWidth / 1.408450704225352;
        if (viewportWidth >= 1025){         
            $("body.pgproduct li.img-left").css( "width", "auto" ).prependTo( "ul#img-left" ) ;  
            $("body.pgproduct li.img-right" ).css( "width", "auto" ).prependTo( "ul#img-right") ;
            $("body.pgproduct li.img-left img, body.pgproduct li.img-right img").css( "width", "100%" ); 
            $('body.pgproduct ul.slides').css('height', '');                          
        } else {
            $("body.pgproduct li.img-right, body.pgproduct li.img-left" ).appendTo("ul.slides").delay(30000).queue(function (next) {
                $(this).appendTo('ul.slides')
                    .css({
                        'width' : flexImgWidth,
                        'float' : 'left',
                        'margin-right' : '0',
                        'display':'block',
                    });                 
                next();
            });            
            $("body.pgproduct li.img-left img, body.pgproduct li.img-right img").css('width' , flexImgWidth);
            $('body.pgproduct ul.slides').css('height', flexImgHeight);             
        }
        if (viewportWidth <= 1025 || $('body.pgproduct div.grid-2n').hasClass('no-sec')) {
            $('body.pgProduct div.item-copy').addClass('tabs-enabled');
            if ($(' div.item-copy.tabs-enabled').length) {
                $('#tabs > div#tab-1').not('#tabs > div[id^="img-"]').show();
                $('#tabs > ul.tab-links li:first').addClass('active');
                $('#tabs div#tab-2').hide('');
                $('#tabs div#tab-3').hide('');
            }
        } else {
            $('body.pgProduct div.item-copy').removeClass('tabs-enabled');
            if ($(' div.item-copy.tabs-enabled').length == 0) {
                $('#tabs > ul.tab-links li').removeClass('active');
                $('#tabs > ul.tab-links li:first').addClass('active');
                $('#tabs > div, #tabs div#tab-2, #tabs > div#tab-1').show();
                $('#tabs div#tab-3').hide('');
            }
        }

    }
    checkWidth();
    $(window).on('resize',checkWidth);
    /*Pinned Header */
    var offset = $( "header" ).offset();
    checkOffset();
    $(window).on('scroll',function() {
        checkOffset();
    });
    function checkOffset() {
        if ( $(document).scrollTop() > offset.top){
            $('header').addClass('fixed');
            if($('.above-promo.earn-burn') && $('.above-promo.earn-burn').css('display') !== 'none'){
                $('.above-promo.earn-burn').addClass('fixed');
                $('header').css('top', $('.above-promo.earn-burn').outerHeight() + 'px');
            }
        } else {
            $('header').removeClass('fixed');
            if($('.above-promo.earn-burn') && $('.above-promo.earn-burn').css('display') !== 'none'){
                $('.above-promo.earn-burn').removeClass('fixed');
                $('header').css('top', $('.above-promo.earn-burn').outerHeight() + 'px');
            }
        } 
    }

    /* Menus*/
    function toggleSites() {
        $('.global-sites div .menu-content-wrapper').fadeToggle(0);
        $('#btn_global').toggleClass('sites-active sites-inactive');
        if ($(".global-sites #btn_global").hasClass('sites-active')) {
            setTimeout(() => {
                const sitesListLinks = document.querySelectorAll('.global-sites a');
                sitesListLinks[0].focus();
            }, 100);
            $('#btn_global').attr('aria-expanded', 'true');
        } else {
            $('#btn_global').attr('aria-expanded', 'false');
        }
    }

    function toggleSearch() {
        const searchBox = $(".searchbox");
        const searchIcon = $("#btn-search");
        const searchButton = $("#searchSubmit");
        const tSearchString = $("#tSearchString");
        let inputVal = $('.search input[type="search"]').val();
        inputVal = String(inputVal).trim().length;
        searchBox.toggleClass("searchbox-open");
        if (searchBox.hasClass("searchbox-open")) {
            searchBox.one("transitionend", () => {
                if (tSearchString !== document.activeElement) {
                    tSearchString.trigger("focus");
                    if(inputVal > 0) {
                        searchButton.removeClass("hidden");
                        searchIcon.addClass("hidden");
                    }
                }
            });
            searchIcon.attr("aria-expanded", "true");
        } else {
            searchButton.addClass("hidden");
            searchIcon.removeClass("hidden");
            searchIcon.attr("aria-expanded", "false");
        }
    }

    function toggleTopNav() {
        $("#btn-main-nav").toggleClass('activated inactive');
        $('ul.top-nav').fadeToggle(0);
        $('body').toggleClass('menu-open');
        if ($("#btn-main-nav").hasClass('activated')) {
            setTimeout(() => {
                const mainNavLinks = document.querySelectorAll('#main-nav a.dropdownLink');
                mainNavLinks[0].focus();
            }, 100);
        }
    }

    function blurCloseSites(event) {
        if ($('.global-sites #btn_global').hasClass('sites-active')) { 
          const currentParentRole = event.srcElement.offsetParent ? event.srcElement.offsetParent.role : null;
          let nextFocusParentRole = null;
          if (event.relatedTarget) {
            nextFocusParentRole = event.relatedTarget.offsetParent ? event.relatedTarget.offsetParent.role : null
          }
          if (currentParentRole !== nextFocusParentRole) {
            toggleSites(); 
          }
        }
    }   

    function blurCloseSearch(event) {
        if ($(".searchbox").hasClass("searchbox-open")) {
            const currentParentID = event.srcElement.offsetParent ? event.srcElement.offsetParent.id : null;
            let nextFocusParentID = null;
            if (event.relatedTarget) {
                nextFocusParentID = event.relatedTarget.offsetParent ? event.relatedTarget.offsetParent.id : null;
            }
            if (currentParentID !== nextFocusParentID) {
                toggleSearch();
            }
        }
    }
    

    function blurCloseMainNav(event) {
        if ($('#btn-main-nav').hasClass('activated')) { 
          const currentParentRole = event.srcElement.offsetParent ? event.srcElement.offsetParent.role : null;
          let nextFocusParentRole = null;
          if (event.relatedTarget) {
            nextFocusParentRole = event.relatedTarget.offsetParent ? event.relatedTarget.offsetParent.role : null
          }
          if (currentParentRole !== nextFocusParentRole) {
              toggleTopNav(); 
              $('#btn-main-nav').trigger('focus');
          }
        }
    }

    function showHideSites () {
        //if( $('.global-sites #btn_global').hasClass('sites-active') ){ toggleSites() }
        if ($(".searchbox").hasClass("searchbox-open")) {
            toggleSearch();
        }
        if ($('#btn-main-nav').hasClass('activated')) { 
            toggleTopNav(); 
        }
        toggleSites();
        if( $('.global-sites #btn_global').hasClass('sites-active') ){ 
          const sitesListLinks = document.querySelectorAll('.global-sites a');
          sitesListLinks.forEach((el) => {
            if(!navigator.userAgent.match(/(iPod|iPhone|iPad|Safari)/)){
            el.addEventListener('blur', blurCloseSites);
            }
          });
        };
    }

    function showHideSearch() {
        if ($(".global-sites #btn_global").hasClass("sites-active")) {
            toggleSites();
        }
        //if( $('.searchbox').hasClass('searchbox-open') ){ toggleSearch() }
        if ($("#btn-main-nav").hasClass("activated")) {
            toggleMainNav();
        }
        toggleSearch();
        if ($(".searchbox").hasClass("searchbox-open")) {
            const searchMenuFocusableEl = document.querySelectorAll(
                '#tSearchContainer [data-ada-focusable="true"]'
            );
            searchMenuFocusableEl.forEach((el) => {
                el.addEventListener("blur", blurCloseSearch);
            });
        }
    }

    function showHideMainNav () {
        if( $('.global-sites #btn_global').hasClass('sites-active') ){ 
            toggleSites() 
        }
        if ($(".searchbox").hasClass("searchbox-open")) {
            toggleSearch();
        }
        // if ($('#btn-main-nav').hasClass('activated')) { 
        //     toggleTopNav(); 
        // }
        toggleTopNav();
        if( $('#btn-main-nav').hasClass('activated') ){ 
          const sitesListLinks = document.querySelectorAll('#main-nav .dropdownLink');
          sitesListLinks.forEach((el) => {
            if(!navigator.userAgent.match(/(iPod|iPhone|iPad|Safari)/)){
                el.addEventListener('blur', blurCloseMainNav);
            }
          });
        };
    }

    $('.global-sites #btn_global').on('mousedown', showHideSites);
    $('.global-sites #btn_global').on('keydown', (event) => {
        if (event.key === 'Enter') {
            showHideSites();
        }
    });

    $("#btn-search").on("mousedown", showHideSearch);
    $("#btn-search").on("keydown", (event) => {
        if (event.key === "Enter") {
            showHideSearch();
        }
    });

    $("#btn-main-nav").on("mousedown", showHideMainNav);
    $("#btn-main-nav").on("keydown", (event) => {
        if (event.key === "Enter") {
            showHideMainNav();
        }
    });

    $(".searchbox .searchbox-input").on("mousedown", (e) => {
        e.stopPropagation();
    });


    $('html').on('click', function() {
        if ($("ul.top-nav").not(".desktop ul.top-nav").is(":visible")) {
            $("ul.top-nav").not('.mobile ul.top-nav').fadeToggle(0);
            $("#btn-main-nav").not('.mobile #btn-main-nav').toggleClass('inactive activated');
            $('body').not('body.mobile').toggleClass('menu-open');
        }
    });
    $('.global-sites > div > button, #btn-main-nav').on('click', function(event) {
        event.stopPropagation();
    });

    function closeLeftNav() {
        $("#btn-left-nav").toggleClass('leftnav-active leftnav-inactive ').next().removeClass('nav-opened');
    }

    $("#btn-left-nav").on('click', function() {
        if ($(this).hasClass("leftnav-inactive")) {
            $("div.left-nav").animate({
                left: '0px'
            }, 200, 'linear');
            $(this).toggleClass('leftnav-inactive leftnav-active').next().addClass('nav-opened');
        } else {
            $("div.left-nav").animate({
                left: '-350px'
            }, 200, 'linear');
            closeLeftNav();
        }
        return false;
    });
    /* Slide In text */
    $('.pghome h1, .main-hp .btn-main, .pghome h2, .pghome .stack p, .bath-tabs li,  .tabs h4, blockquote, .quoter').not('.linens .tab_container h2').addClass("hidden").viewportChecker({
        classToAdd: 'visible animation fadeInUp',
        offset: 0
    });
    $('img.img-flash').addClass("hidden").viewportChecker({
        classToAdd: 'visible animation flash',
        offset: 450
    });
    /*Flexslider */
    $(window).on('load', function() {
        $('.item-image, .slider, .slides').flexslider({
            animation: "slide",
            animationLoop: false,
            useCSS: false
        });
    });

    /*ADA AAA 
    Main navigation mneu*/
    $(function () {
        var $dropdowns = $("#main-nav .dropdown");
        var $dropdownsLinks = $("#main-nav .dropdownLink");
        $dropdownsLinks.on("focus",function(){
          let $thisParent = $(this).parent();
          $dropdowns.removeClass("hover");
          $dropdownsLinks.attr("aria-expanded", "false");
          $thisParent.addClass("hover");
          $(this).attr("aria-expanded", "true");
        })
    
        $('#main-nav').on("focusout", function() {
            setTimeout(() => {
              // if active element is outside the div.header-container...
              if ($(document.activeElement).parents('#main-nav').length === 0) {
                // remove hover functionality
                $dropdowns.removeClass("hover");
                $dropdownsLinks.attr("aria-expanded", "false");
              }
            }, 100);
        })

        // let fitstNavChild = $("#main-nav [role=menuitem]").first()[0];
        // $(fitstNavChild).on("keydown", function(e) {
        //   if(e.key === 'Tab' && e.shiftKey) {
        //     $dropdowns.removeClass("hover");
        //     $dropdownsLinks.attr("aria-expanded", "false");
        //   }
        // })
    
        // let lastNavChild = $("#main-nav [role=menuitem]").last()[0];
        // $(lastNavChild).on("keydown", function(e) {
        //   if(e.key === 'Tab') {
        //     $dropdowns.removeClass("hover");
        //     $dropdownsLinks.attr("aria-expanded", "false");
        //   }
        // })
    }); 

/*Hover Intent*/
    var $dropdowns = $('.shop-cart, .top-nav > li');
    $dropdowns
        .on('mouseover', function() {
            var $this = $(this);
            if ($this.prop('hoverTimeout')) {
                $this.prop('hoverTimeout', clearTimeout($this.prop('hoverTimeout')));
            }
            $this.prop('hoverIntent', setTimeout(function() {
                $this.addClass('hover');
            }, 200));
        })
        .on('mouseleave', function() {
            var $this = $(this);
            if ($this.prop('hoverIntent')) {
                $this.prop('hoverIntent', clearTimeout($this.prop('hoverIntent')));
            }
            $this.prop('hoverTimeout', setTimeout(function() {
                $this.removeClass('hover');
            }, 400));
        });
           

    if ($("body").hasClass("pghome")) {
    /* Homepage Linens Section */
            swatchSlider.init({
            swatchTabs: ["tab2","tab3"], //Optional. If present, it will only attach swatch animations to tabs in the array.
            animeConfig: { //Optional. If present, it will override default animation delays/duration
                initialDelay: 1.5, //Animation start delay
                h2Duration: 1, //H2 tag tween speed
                ctaDuration: 0.5, //CTA tween speed
                arrowDuration: 0.5 //Arrow movement speed
            }
        });
    }

    /*Homepage */
    /*Bedding Accordion Section */
    var sections = [].slice.call(document.getElementsByClassName('child')),
        $acContainer = $(".child").length,
        $overWidth = 40,
        tl;

    sections.forEach(function(section) {
        // get heading and button for this section
        var acHeading = section.querySelector("h2 em"),
            acButton = section.querySelector("h2 > span");
        // create timeline action for this section
        var tlMoveAcTitle = gsap.timeline({
            paused: true
        });
        tlMoveAcTitle
            .fromTo(acHeading, 
                { 
                    duration: 0.2, 
                    y: 50, 
                    ease: "none", 
                    opacity: 1 
                }, 
                { 
                    duration: 0.2, 
                    y: 0, 
                    ease: "none", 
                    opacity: 1 
                }
            )
            .fromTo(acButton, 
                { 
                    duration: 0.01, 
                    y: 50, 
                    ease: "none", 
                    opacity: 0 
                }, 
                { 
                    duration: 0.01, 
                    y: 0, 
                    ease: "none", 
                    opacity: 1 
                }
            );
        // timeline events for this section
        [
            ["mouseenter", over],
            ["mouseleave", out],
        ].forEach(function(arr) {
            var event = arr[0],
                fnRef = arr[1];
            section.addEventListener(event, function() {
                fnRef(tlMoveAcTitle, section);
            });
        });
        [
            ["focus", over],
            ["focusout", out],
        ].forEach(function(arr) {
            var event = arr[0],
                fnRef = arr[1];
            section.querySelector("a").addEventListener(event, function() {
                fnRef(tlMoveAcTitle, section);
            });
        });
    });

    gsap.set($(".child"), {
        width: 100 / $acContainer + "%"
    });

    function over(timeline, section) {
        gsap.to($(section), {
            duration: 0.3,
            width: $overWidth + "%"
        });
        gsap.to($(section).siblings(), {
            duration: 0.3,
            width: (100 - $overWidth) / ($acContainer - 1) + "%"
        });
        timeline.play();
    }

    function out(timeline, section) {
        gsap.to($(".child"), {
            duration: 0.3,
            width: 100 / $acContainer + "%",
            ease: "back"
        });
        timeline.reverse();
    }

    function childHeight() {
        var childWidth = $('.child').width();
        $('.child').css({ 'height': childWidth + 40 + 'px' });
        $('.child img').css({ 'height': childWidth + 70 + 'px' });

    }
    /*End Bedding Accordion Section */
    // Designers Section
    function findDesignerHeight() {
        var designerSlider = $('.designers .slider');
        var imgHeight = $('.designers #img-height').height();
        $(designerSlider).css({'height': imgHeight + 'px'});
    }
       /* Bath Section */
    if ($("body").hasClass("pghome") == true) {
 
        var tlBathTabs = gsap.timeline();
        function bathTabs() {
            // ADA tab behaviour
            const $this = $(this);
            const $sibling = $this.siblings();

            $sibling.removeClass('active').attr({
            'tabindex': '-1',
            'aria-selected': 'false'
            });

            $this.addClass('active').attr({
            'tabindex': '0',
            'aria-selected': 'true'
            });

            var currentTab = $this.attr('aria-controls');
            $("#bathTabsHP > div").hide();
            $(`#${currentTab}`).show();
            // End ADA 
            var $label = $('.label');
            var el_width = $this.width();
            var offset_left = $this.offset();
            var initTabNum = $this.data('menu');
            var $bathImg = $('.bath-img');
            //var $show = $('.show');

            function step_1() {
                $bathImg.removeClass('show');
            }

            function step_2() {
                $('.bath_' + initTabNum).addClass('show');
            }

            if (tlBathTabs && tlBathTabs.isActive()) {
                tlBathTabs.progress(1);
            }

            if (!tlBathTabs.isActive()) {

                tlBathTabs

                    .to($bathImg, {
                        duration: 0.3,
                        opacity: 1,
                        ease: "none",
                        onComplete: step_1
                    })
                    .fromTo($('.bath_' + initTabNum), {
                        duration: 0.3,
                        scale: 1.03,
                    }, {
                        onStart: step_2,
                        scale: 1,
                        ease: "power4",
                        immediateRender: false
                    });

                //.to($bath-img, 0, {y: 0, ease: Sine.easeOut}) 
                $label.offset({
                    left: offset_left.left
                }).css('width', el_width);
                $('.bath-tabs button').removeClass('bath_active');
                $this.addClass('bath_active');
            }
        }
        $('.bath-tabs button').on('mouseover', bathTabs);
        $('.bath-tabs button').on('click', bathTabs);

        var initSize = function() {
            var start_element = $('.bath-tabs button:nth-child(1)');
            var $label = $('.label');
            var initWidth = start_element.css('width');
            $label.css('width', initWidth);
        };
        initSize();
        /* End Bath Section */
        var btnNext,btnPrev;
        if ($("body").hasClass("pghome")) {
        
            // Designers Section
            var sliderItems = document.querySelectorAll('.designer-item');
            btnNext = document.querySelector('.designer-arrows-right');
            btnPrev = document.querySelector('.designer-arrows-left');
        }   
        // Slider
        var Slider = {
            currentItem: 0,

            init: function init() {
                sliderItems.forEach(function(item) {
                    item.style.visibility='hidden'
                })
                Slider.in(Slider.currentItem);
            },

            in: function _in(index) {
                var item = sliderItems[index];
                var texts = item.querySelectorAll('div.designer-left');
                var timeline = gsap.timeline();

                gsap.set(item, { autoAlpha: 0, scale: 0.9, left: '-100vw' });

                timeline.to(item, 0.5, { left: 0, delay: 0.4, autoAlpha: 1 }).to(item, 0.5, { scale: 1 }).staggerFrom(texts, 0.5, { y: 300, autoAlpha: 0, ease: Back.easeOut }, 0.2);
            },

            out: function out(index, nextIndex) {
                var item = sliderItems[index];
                var texts = item.querySelectorAll('div.designer-left');
                var timeline = gsap.timeline();
                timeline.to(texts, { duration: 0.4, y: 300, autoAlpha: 0, ease: "back.in", stagger:"-0.5" }).call(Slider.in, [nextIndex], undefined).to(item, 0.4, { scale: 0.9, autoAlpha: 0 }).to(item, 0.4, { left: '100vw', autoAlpha: 0 }).set(texts, { clearProps: 'all' });
            },

            next: function next() {
                var next = Slider.currentItem !== sliderItems.length - 1 ? Slider.currentItem + 1 : 0;
                Slider.out(Slider.currentItem, next);
                Slider.currentItem = next;
            },

            prev: function prev() {
                var prev = Slider.currentItem > 0 ? Slider.currentItem - 1 : sliderItems.length - 1;
                Slider.out(Slider.currentItem, prev);
                Slider.currentItem = prev;
            }

            // Events
        };
        btnNext.addEventListener('click', Slider.next);
        btnPrev.addEventListener('click', Slider.prev);

        Slider.init();

    }
        function findAltLinenHeight() {
            var linenAnchor = $('body.pgproduct .linens ul.colors li a ');
            var linenImgHeight = $('body.pgproduct .linens li:first-child img').height();
            $(linenAnchor).css({'height': linenImgHeight + 'px'});
        }
        if ($("body").hasClass("pgproduct")) {
            if($("ul.colors li").length < 3) {
                $('.linens ul.colors').css("padding-bottom", "20%");
            }
            $("ul.colors li:first-child").addClass("current");
            $("ul.colors li button").on("mouseenter focus", function(event) {
                $("ul.colors li.current").removeClass("current");
                $(this).closest('li').addClass("current");

                var recipient = ".target";
                var animation;
                var trigger = "ul.colors li p";

                event.stopPropagation();
                let pWrappingTag = $(this).parent();
                if (!pWrappingTag.hasClass('current')) {
                    var parentElm = pWrappingTag.parent();
                    var targetChild = parentElm.find(recipient);
    
                    $(trigger).removeClass('current');
                    $(recipient).removeClass('open');
    
                    pWrappingTag.addClass('current');
                    targetChild.addClass('open');
    
                    if (animation) {
                        animation.reverse();
                    }
                    animation = gsap.fromTo(targetChild, 0.3, {
                        display: 'none',
                        y: '-100%',
                        autoAlpha: 0
                    }, {
                        display: 'block',
                        y: '0%',
                        autoAlpha: 1,
                        ease: "power1"
                    });
                }
            });
            
            $(window).on('load resize', function() {
                slidingLine();
                findAltLinenHeight();
            });
        }

        /* Function for vertical product page sliding arrow */
        function slidingLine() {
            var $el, topPos, newHeight,
                $navContainer = $("div.colors-wrapper");

            // Create a new li and append it to ul
            $navContainer.append("<span class='linens-arrow'><span></span></span>");
            var $slidingLine = $(".linens-arrow");
            var $paragraph = $(".current p");
            if ($paragraph.length) {
                $slidingLine // Defining initial height and position
                    .height($(".current p").outerHeight())
                    .width($(".current p").outerWidth())
                    .css("top", $(".current p").position().top)
                    .data("origTop", $slidingLine.position().top)
                    .data("origHeight", $slidingLine.height());
            }
            $("ul.colors li button").on('mouseenter focus', function() { // Set new height and position
                $el = $(this);
                topPos = $el.position().top;
                newHeight = $el.outerHeight();
                $slidingLine.stop().animate({
                    top: topPos,
                    height: newHeight
                });
            }, function() { // Animate
                $slidingLine.stop().animate({
                    top: $(".current p").position().top,
                    height: $(".current p").outerHeight()
                });
            });
        }   
    /*Fancybox*/
    $('.item-image .slides li a, .fancybox').fancybox({
        openEffect: 'elastic',
        openSpeed: 350,
        closeEffect: 'elastic',
        closeSpeed: 350,
        nextEffect: 'fade',
        nextSpeed: 200,
        padding: 2,
        margin: 20
    });

    /* Promo Headers - */
    (function($) {
        $.fn.flowtype = function(options) {
            var settings = $.extend({
                    maximum: 9999,
                    minimum: 1,
                    maxFont: 9999,
                    minFont: 1,
                    fontRatio: 35
                }, options),
                changes = function(el) {
                    var $el = $(el),
                        elw = $el.width(),
                        width = elw > settings.maximum ? settings.maximum : elw < settings.minimum ? settings.minimum : elw,
                        fontBase = width / settings.fontRatio,
                        fontSize = fontBase > settings.maxFont ? settings.maxFont : fontBase < settings.minFont ? settings.minFont : fontBase;
                    $el.css('font-size', fontSize + 'px');
                };

            return this.each(function() {
                var that = this;
                $(window).on('resize',function() {
                    changes(that);
                });
                changes(this);
            });
        };
    }(jQuery));

    $('#hdr-banner p, .sweeps_banner').flowtype({
        minimum: 420,
        maximum: 1200,
        minFont: 16,
        maxFont: 45,
        fontRatio: 35
    });
    $('.promo-wrapper .promo-inner').flowtype({
        minimum: 420,
        maximum: 1200,
        minFont: 10,
        maxFont: 21,
        fontRatio: 50
    });
    /*Detections*/
    var root = document.getElementsByTagName('html')[0];
    if (!document.createElement('svg').getAttributeNS) {
        root.setAttribute("class", "no-svg");
        return;
    }
    /* IE 10 Detection due to checkbox issues*/
    if (Function('/*@cc_on return document.documentMode===10@*/')()) {
        document.documentElement.className += ' ie10';
    }
    
    //Add a class to the last letter on left nav so arrow travels with it
    /*Search */

    $(window).on('load resize', function() {
        findDesignerHeight();
        childHeight();
    });

    /*END DOC READY*/
});

/*Tabs Description/details */
$(function () {
    let viewportWidth = window.viewportSize.getWidth();
    let isNoSecProductPage = $('body.pgproduct div.grid-2n').hasClass('no-sec')

    if (isNoSecProductPage || viewportWidth <= 1025) {
        const $tabLinksWrap = $('#tabs > .tab-links');
        const $tabFirstBtn = $tabLinksWrap.find('button').eq(0);
    
        $("#tabs > div").hide();
        $("#tabs > div:first").show();
        $tabFirstBtn.addClass('active');
        
        $tabLinksWrap.on('click', 'button', function () {
            const $this = $(this);
            const $sibling = $this.siblings();
        
            $sibling.removeClass('active').attr({
                'tabindex': '-1',
                'aria-selected': 'false'
            });
        
            $this.addClass('active').attr({
                'tabindex': '0',
                'aria-selected': 'true'
            });
        
            var currentTab = $this.attr('aria-controls');
            $("#tabs > div").hide();
            $(`#${currentTab}`).show();
        
            return false;
        });
    }
});


/* Videos */
 var screenWidth = window.viewportSize.getWidth();
(function(a){(jQuery.browser=jQuery.browser||{}).mobile=/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))})(navigator.userAgent||navigator.vendor||window.opera);
if(!jQuery.browser.mobile || screenWidth >=768)
    {
        console.log('not mobile');
      $("body.pghome #hp-video")
      .html("<video autoplay loop muted><source src='videos/hp-french-way.mp4' type='video/mp4'><source src='videos/hp-french-way.webm' type='video/webm'><source src='videos/hp-french-way.ogv' type='video/ogg'></video>");
    }
else
    {
        $('video').hide();
    }
/*Homepage Linen Section */
var swatchSlider = (function () {
    var current = {};
    var animeConfig = {
        initialDelay: 1.5,
        h2Duration: 1,
        ctaDuration: 0.5,
        arrowDuration: 0.5
    };
    function initSwatchSlider(config){
                            $(".tab_content").hide();
        $(".tab_content:first").show();
        var tabs = $('.tabs button');
        tabs.each(function(i,tab){ //Attach event handlers for tabs and swatch colors
            var activeTab = $(tab).attr("rel");
            var swatchTab = true;
            if(config && config.swatchTabs) {
                swatchTab = (config.swatchTabs.indexOf(activeTab) === -1) ? false : true;
            }
            $(tab).on('click', function(e){
                e.stopPropagation();
                // ADA tab behaviour
                const $this = $(this);
                const $sibling = $this.siblings();

                $sibling.removeClass('active').attr({
                'tabindex': '-1',
                'aria-selected': 'false'
                });

                $this.addClass('active').attr({
                'tabindex': '0',
                'aria-selected': 'true'
                });

                var currentTab = $this.attr('aria-controls');
                // end ADA script
                $("#tabs > div").hide();
                $(`#${currentTab}`).show();
                $(".tab_content").hide();
                $("#" + activeTab).fadeIn();
                $(".tabs button").removeClass("active");
                $(tab).addClass("active");
                $(".tab_drawer_heading").removeClass("d_active");
                $(".tab_drawer_heading[rel^='" + activeTab + "']").addClass("d_active");
                if(swatchTab) {
                    set($("#" + activeTab + " li button:first"));
                } else {
                    $("#" + activeTab + " .target").show();
                }
            });
            if(swatchTab) {
                function activateSwatch(event) {
                    set(event.currentTarget);
                }
                $("#" + activeTab + ' li button')
                    .on('mouseover', activateSwatch)
                    .on("focus", activateSwatch);
            }
        });
        if(config && config.animeConfig) {
            overrideDefaults(config.animeConfig);
        }
    }
    function overrideDefaults(obj) {
        for(var attr in obj){
            animeConfig[attr] = obj[attr];
        }
    }
    function showHideSwatch() {
        $('.target').hide();
        $('#' + current.targetVal).show();
    }
    function getxCenterPercentage(element){
        var elemWidth = $(element).width();
        var parentWidth = $('#' + current.targetVal).width();
        var xPercentage = (parentWidth/2-elemWidth/2)*100/parentWidth;      
        return xPercentage.toString() + '%';
    }
    function getyCenterPercentage(element){
        var elemHeight = $(element).height();
        var parentHeight = $('#' + current.targetVal).height();
        var yPercentage = (parentHeight/2-elemHeight/2)*100/parentHeight;   
        return yPercentage.toString() + '%';
    }
    function animateArrow(){
        var activeTab = $(".tabs button.active").attr("rel");
        var arrow = $("#" + activeTab + "-arrow");
        var arrowOffset = 0;
        var initElem = ("#" + activeTab + " button:first");
        arrowOffset = $(current.elem).offset().top - $(initElem).offset().top;
        gsap.to(arrow, animeConfig.arrowDuration, {y: arrowOffset, ease: "back"});
    }
    function set(elem) {
        current.elem = elem;
        var tmpTargetVal = current.targetVal || "";
        current.targetVal = $(current.elem).attr("data-target-id");
        if(tmpTargetVal !== current.targetVal) {
            showHideSwatch();
            animateArrow();
            var elemAnimated = $(elem).attr("data-animated");
            if(!elemAnimated){ //Animate only if previously not animated
                current.imgCollection = $('#' + current.targetVal + ' img');
                current.h2 = $('#' + current.targetVal + ' h2');
                current.cta = $('#' + current.targetVal + ' .btn-white');
                animateSwatch();
                $(elem).attr("data-animated","true");
            }
        }   
    }
    function animateSwatch() {
        var tl = gsap.timeline();
        tl.set(current.h2, {visibility:"visible"})
            .to(current.imgCollection[0], 1, { autoAlpha: 0, delay: animeConfig.initialDelay })
            .from(current.h2,animeConfig.h2Duration,{right:getxCenterPercentage(current.h2), bottom:getyCenterPercentage(current.h2)},"-=1")
            .set(current.cta, {visibility:"visible"})
            .from(current.cta, animeConfig.ctaDuration, {y: 100}, "-=.5");
    }
    return {
        init: function(config){
            initSwatchSlider(config);
        }
    };
})();

function buttonUp() {
    let inputVal = $('.search input[type="search"]').val();
    inputVal = String(inputVal).trim().length;
    if (inputVal !== 0) {
        $('.icon-search').addClass('hidden');
        $('.search-submit').removeClass('hidden');
    } else {
        $('.search input[type="search"]').val('');
        $('.search-submit').addClass('hidden');
        $('.icon-search').removeClass('hidden');
    }
}

/*END SHOULD BE OUTSIDE OF DOC READY */

/*Slide In Animations Viewport Check*/
(function($) {
    $.fn.viewportChecker = function(useroptions) {
        var options = {
            classToAdd: 'visible',
            offset: 100,
            callbackFunction: function(elem) {}
        };
        $.extend(options, useroptions);
        var $elem = this,
            windowHeight = $(window).height();

        this.checkElements = function() {
            // Set some vars to check with
            var viewportTop = Math.max($('html').scrollTop(), $('body').scrollTop(), $(window).scrollTop()),
                viewportBottom = (viewportTop + windowHeight);

            $elem.each(function() {
                var $obj = $(this);
                if ($obj.hasClass(options.classToAdd)) {
                    return;
                }
                var elemTop = Math.round($obj.offset().top) + options.offset,
                    elemBottom = elemTop + ($obj.height());
                if ((elemTop < viewportBottom) && (elemBottom > viewportTop)) {
                    $obj.addClass(options.classToAdd);
                    options.callbackFunction($obj);
                }
            });
        };
        $(window).on('scroll',this.checkElements);
        this.checkElements();
        $(window).on('resize',function(e) {
            windowHeight = e.currentTarget.innerHeight;
        });
    };
})(jQuery);